var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useEffect, useRef, useState } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import TextField from '@material-ui/core/TextField';
import CheckIcon from '@material-ui/icons/Check';
import { dVariant } from 'component/config';
// style----------------------------------------------------
var StyleTextField = withStyles({
    root: {
        width: '100%',
        '& input, .MuiInputBase-multiline': {
            padding: '0.675em 0.75em',
            fontSize: '1.15em',
        },
    },
})(TextField);
// Input----------------------------------------------------
export var GreenCheck = function (props) { return React.createElement(CheckIcon, __assign({ style: { color: 'green' } }, props)); };
var Input = function (props) {
    var value = props.value, onChange = props.onChange, _a = props.variant, variant = _a === void 0 ? dVariant : _a, _b = props.inputRef, inputRef = _b === void 0 ? useRef() : _b, _c = props.verifyBeforeChange, verifyBeforeChange = _c === void 0 ? false : _c, inputProps = props.inputProps, _d = props.minLength, minLength = _d === void 0 ? inputProps === null || inputProps === void 0 ? void 0 : inputProps.minLength : _d, _e = props.maxLength, maxLength = _e === void 0 ? inputProps === null || inputProps === void 0 ? void 0 : inputProps.maxLength : _e, error = props.error, helperText = props.helperText, other = __rest(props, ["value", "onChange", "variant", "inputRef", "verifyBeforeChange", "inputProps", "minLength", "maxLength", "error", "helperText"]);
    var _f = props.verifiers, verifiers = _f === void 0 ? [] : _f;
    var _g = useState(''), message = _g[0], setMessage = _g[1];
    var _h = useState(verifyBeforeChange), firstVerify = _h[0], setFirstVerify = _h[1];
    if (minLength && value) {
        verifiers = __spreadArrays([
            {
                func: function (v) { return v.length < minLength; },
                text: "\u8ACB\u5C07\u9019\u6BB5\u6587\u5B57\u52A0\u9577\u5230 " + minLength + " \u500B\u5B57\u5143\u4EE5\u4E0A (\u76EE\u524D\u4F7F\u7528\u5B57\u5143\u6578\uFF1A" + value.length + ")\u3002",
            }
        ], verifiers);
    }
    useEffect(function () {
        setFirstVerify(verifyBeforeChange);
    }, [verifyBeforeChange]);
    useEffect(function () {
        // 始設畫面預設不 verify , 除非 verifyBeforeChange = true
        if (!firstVerify)
            return;
        // 驗使用者設定之 verifier, 不驗空值(給 HTML required 驗)
        if (value && verifiers.length > 0) {
            var veriObj = verifiers.find(function (obj) { return obj.func(value); });
            if (veriObj) {
                setMessage(veriObj.text);
                return;
            }
        }
        // 驗 HTML validation
        if (inputRef.current && inputRef.current.validationMessage.length > 0) {
            setMessage(inputRef.current.validationMessage);
            return;
        }
        // 先前檢驗都 pass
        setMessage('');
    }, [value, firstVerify]);
    return (React.createElement(StyleTextField, __assign({ fullWidth: true, size: "small", variant: variant }, other, { value: value, onChange: function (e) {
            setFirstVerify(true);
            if (onChange) {
                onChange(e);
            }
        }, inputRef: inputRef, inputProps: __assign(__assign({ onClick: function (e) { return e.stopPropagation(); } }, inputProps), { minLength: minLength,
            maxLength: maxLength }), error: error || message.length > 0, helperText: message || helperText })));
};
export default Input;
